import React from 'react'

export const contactFields = [
  { field: 'FirstName', label: 'First Name' },
  { field: 'LastName', label: 'Last Name' },
  { field: 'Email', label: 'Email' },
  { field: 'WorkPhone', label: 'Work Phone * (Required)' },
  { field: 'NotCorporateEmailReason', label: 'Not Corporate Email Reason' },
  {
    field: 'NotCorporateEmailReasonComment',
    label: 'Not Corporate Email Reason Comment',
  },
  { field: 'JobTitle', label: 'Job Title' },
]

export const contactValidateEmeaFields = [
  { field: 'FirstName', label: 'First Name' },
  { field: 'LastName', label: 'Last Name' },
  { field: 'Email', label: 'Email' },
  { field: 'WorkPhone', label: 'Work Phone * (Required)' },
  { field: 'JobTitle', label: 'Job Title' },
]

export const partnerFields = [{ field: 'RegistrationNumber', label: 'Registration Number' }]
